import { PREFETCH_SERVICES, BuilderPrefetchService } from '@scalefast/ecommerce-core';
import { ContentfulPrefetchService } from './services/contentful-prefetch.service';

/**
 * This provides a list of the prefetch services used in the store.
 * We use this factory function with the PREFETCH_SERVICES injection token key.
 * In this way the services will be available to be used for prefetching data.
 */
export function providePrefetch() {
  return {
    provide: PREFETCH_SERVICES,
    useFactory: (builderPrefetchService: BuilderPrefetchService, contentfulPrefetchService: ContentfulPrefetchService) => {
      return [builderPrefetchService, contentfulPrefetchService];
    },
    deps: [BuilderPrefetchService, ContentfulPrefetchService],
  };
}
